
import React from 'react';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { useEffect, useState } from 'react';

interface PricingHeaderProps {
  title: string;
  description: string;
}

const PricingHeader: React.FC<PricingHeaderProps> = ({ title, description }) => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  const [displayedTitle, setDisplayedTitle] = useState<string[]>([]);
  const titleWords = ["Simple,", "transparent", "pricing"];

  useEffect(() => {
    if (isVisible) {
      const animateWords = async () => {
        for (let i = 0; i < titleWords.length; i++) {
          await new Promise((resolve) => setTimeout(resolve, 150));
          setDisplayedTitle(prev => [...prev, titleWords[i]]);
        }
      };
      animateWords();
    }
  }, [isVisible]);

  return (
    <div className="relative bg-[#FAF9F8]">
      <div 
        ref={ref}
        className="relative z-10 max-w-[1200px] mx-auto px-6 pt-32 pb-16"
      >
        <h1 className="text-[50px] md:text-[65px] lg:text-[80px] leading-[1.1] md:leading-[1] font-charter font-medium tracking-tighter text-[#141413] mb-8">
          <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-5">
            <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-5 basis-full md:basis-auto">
              {titleWords.slice(0, 2).map((word, index) => (
                <span
                  key={index}
                  className={`transition-all duration-300 transform ${
                    displayedTitle.includes(word)
                      ? 'opacity-100 translate-y-0'
                      : 'opacity-0 translate-y-8'
                  }`}
                >
                  {word}
                </span>
              ))}
            </div>
            <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-5 w-full md:mt-2">
              {titleWords.slice(2).map((word, index) => (
                <span
                  key={index + 2}
                  className={`transition-all duration-300 transform ${
                    displayedTitle.includes(word)
                      ? 'opacity-100 translate-y-0'
                      : 'opacity-0 translate-y-8'
                  }`}
                >
                  {word}
                </span>
              ))}
            </div>
          </div>
        </h1>
        <div 
          className={`max-w-[600px] mx-auto transition-all duration-700 delay-700 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <p className="text-base md:text-xl text-[#141413]/80 text-center">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PricingHeader;
